import { render, staticRenderFns } from "./sidebar-discount-codes.vue?vue&type=template&id=132b8753&"
import script from "./sidebar-discount-codes.vue?vue&type=script&lang=js&"
export * from "./sidebar-discount-codes.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-discount-codes.vue?vue&type=style&index=0&id=132b8753&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports